import { IconType } from 'react-icons';
import { FiEdit, FiFileText, FiHome, FiLogOut } from 'react-icons/fi';
import {
  FeatureFlagNameEnum,
  UserEntitlementsEnum,
} from '@keyops-cep/api-client';

import { getEntitlements } from '../../../api/auth.functions';
import i18n from '../../../utils/i18n';
import {
  DASHBOARD,
  DRAFT_SURVEY,
  EVALUATION_EVENTS,
  LOGOUT,
} from '../../../utils/internal-routes.const';

export interface LinkItemProps {
  name: string;
  icon: IconType;
  path: string;
  hidden?: boolean;
  requiredFeatureFlag?: FeatureFlagNameEnum;
  canShow: () => boolean;
}

export const SidebarNavItems: Array<LinkItemProps> = [
  {
    name: i18n.t('sidebar.sidebarNavItems.home'),
    icon: FiHome,
    path: DASHBOARD,
    canShow: () => true,
  },
  {
    name: i18n.t('sidebar.sidebarNavItems.draftSurvey'),
    icon: FiEdit,
    path: DRAFT_SURVEY,
    requiredFeatureFlag: FeatureFlagNameEnum.EngageAISurveyDrafting,
    canShow: () => true,
  },
  {
    name: i18n.t('sidebar.sidebarNavItems.evaluationEvents'),
    icon: FiFileText,
    path: EVALUATION_EVENTS,
    requiredFeatureFlag: FeatureFlagNameEnum.CustomerProgramEvaluation,
    canShow: () => {
      const entitlements = getEntitlements();
      return (
        entitlements.includes(UserEntitlementsEnum.AccessOwnEvaluationEvents) ||
        entitlements.includes(UserEntitlementsEnum.AccessAllEvaluationEvents)
      );
    },
  },
];

export const LogoutSidebarNavItem: Array<LinkItemProps> = [
  {
    name: i18n.t('sidebar.sidebarNavItems.logout'),
    icon: FiLogOut,
    path: LOGOUT,
    canShow: () => true,
  },
];
